<template>
  <div>

    <div class="flex flex-wrap -mx-1 lg:-mx-2">

      <div class="w-full md:w-1/3 px-1 lg:px-2">
        <dashboard-box
          name="income"
          price-class="text-green-500"
          :selected-button.sync="selectedTotal.income"
          :total="total[selectedTotal.income].current ? total[selectedTotal.income].current.income : 0"
          :grant-total="total.grant.income"
          :percentage-increase="incomeIncrease"
        />
      </div>

      <div class="w-full md:w-1/3 px-1 lg:px-2">
        <dashboard-box
          name="expense"
          price-class="text-red-500"
          :selected-button.sync="selectedTotal.expense"
          :total="total[selectedTotal.expense].current ? total[selectedTotal.expense].current.expense : 0"
          :grant-total="total.grant.expense"
          :percentage-increase="expenseIncrease"
        />
      </div>
      <div class="w-full md:w-1/3 px-1 lg:px-2">
        <dashboard-box
          name="revenue"
          price-class="text-purple-300 light:text-purple-500"
          :selected-button.sync="selectedTotal.revenue"
          :total="revenue"
          :grant-total="total.grant.income - total.grant.expense"
          :percentage-increase="revenueIncrease"
        />
      </div>
    </div>


    <div class="flex flex-wrap -mx-1 lg:-mx-2">
      <div class="w-full md:w-1/2 px-1 lg:px-2">
        <div class="box">
          <div class="flex flex-wrap mb-2">
            <p class="mb-3 flex-grow text-center md:text-left">Income & expense daily</p>
            <div class="flex-grow text-center md:text-right">
              <button
                class="btn text-xs rounded-r-none"
                :class="charts.incomeExpense.dateRangeID === 'current-month' ? 'btn-green' : 'bg-theme'"
                @click="selectChartDateID('incomeExpense', 'current-month')"
              >Current month</button>
              <button
                class="btn text-xs rounded-none"
                :class="charts.incomeExpense.dateRangeID === 'previous-month' ? 'btn-green' : 'bg-theme'"
                @click="selectChartDateID('incomeExpense', 'previous-month')"
              >Previous month</button>
              <button
                class="btn text-xs rounded-none"
                :class="charts.incomeExpense.dateRangeID === 'last-30-days' ? 'btn-green' : 'bg-theme'"
                @click="selectChartDateID('incomeExpense', 'last-30-days')"
              >Last 30 days</button>
            </div>
          </div>
          <income-expense-line-chart :selectedDateRangeID="charts.incomeExpense.dateRangeID"/>
        </div>
      </div>
      <div class="w-full md:w-1/2 px-1 lg:px-2">
        <div class="box">
          <div class="flex flex-wrap mb-2">
            <p class="mb-3 flex-grow text-center md:text-left">Job types count</p>
            <div class="flex-grow text-center md:text-right">
              <button
                class="btn text-xs rounded-r-none"
                :class="charts.jobTypes.dateRangeID === 'current-month' ? 'btn-green' : 'bg-theme'"
                @click="selectChartDateID('jobTypes', 'current-month')"
              >Current month</button>
              <button
                class="btn text-xs rounded-none"
                :class="charts.jobTypes.dateRangeID === 'previous-month' ? 'btn-green' : 'bg-theme'"
                @click="selectChartDateID('jobTypes', 'previous-month')"
              >Previous month</button>
              <button
                class="btn text-xs rounded-none"
                :class="charts.jobTypes.dateRangeID === 'last-30-days' ? 'btn-green' : 'bg-theme'"
                @click="selectChartDateID('jobTypes', 'last-30-days')"
              >Last 30 days</button>
            </div>
          </div>
          <job-type-chart :selectedDateRangeID="charts.jobTypes.dateRangeID"/>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap -mx-1 xl:-mx-2" v-if="hasPermission('invoice.edit')">
      <div class="w-full xl:w-1/2 px-1 xl:px-2">
        <div class="box">
          <p class="">Not settled invoices</p>
          <invoice-list :is-settled="false" :show-actions="false" :compact="true"/>
        </div>
      </div>
      <div class="w-full xl:w-1/2 px-1 xl:px-2" v-if="hasPermission('reminder.view')">
        <div class="box">
          <p class="">Latest reminders</p>
          <reminder-list :show-actions="false" :compact="true"/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
const InvoiceList = resolve => require(['@/components/pages/invoices/List'], resolve)
const ReminderList = resolve => require(['@/components/pages/reminders/List'], resolve)
const IncomeExpenseLineChart = resolve => require(['@/components/pages/reports/IncomeExpenseLineChart'], resolve)
const JobTypeChart = resolve => require(['@/components/pages/reports/JobTypeChart'], resolve)
const DashboardBox = resolve => require(['@/components/DashboardBox'], resolve)

export default {
  components: {
    InvoiceList,
    ReminderList,
    IncomeExpenseLineChart,
    JobTypeChart,
    DashboardBox,
  },
  data() {
    return {
      // selectedTotal: 'month',
      selectedTotal: {
        income: 'month',
        expense: 'month',
        revenue: 'month',
      },
      total: {
        grant: {},
        month: {
          current: 0,
          previous: 0,
        },
        week: {
          current: 0,
          previous: 0,
        },
        day: {
          current: 0,
          previous: 0,
        },
      },
      charts: {
        incomeExpense: {
          dateRangeID: 'current-month',
        },
        jobTypes: {
          dateRangeID: 'current-month',
        }
      },
    }
  },
  watch: {
    'selectedTotal.revenue'(r) {
      this.selectedTotal.income = r
      this.selectedTotal.expense = r
    }
  },
  computed: {
    revenue() {
      if (this.total[this.selectedTotal.revenue].current) {
        return this.total[this.selectedTotal.revenue].current.income - this.total[this.selectedTotal.revenue].current.expense
      }
      return 0
    },
    incomeIncrease() {
      let current = this.total[this.selectedTotal.income].current ? this.total[this.selectedTotal.income].current.income : 0
      let previous = this.total[this.selectedTotal.income].previous ? this.total[this.selectedTotal.income].previous.income : 0
      if (!current) {
        return 0
      }
      return (current - previous) / current * 100
    },
    expenseIncrease() {
      let current = this.total[this.selectedTotal.expense].current ? this.total[this.selectedTotal.expense].current.expense : 0
      let previous = this.total[this.selectedTotal.expense].previous ? this.total[this.selectedTotal.expense].previous.expense : 0
      if (!current) {
        return 0
      }
      return (current - previous) / current * 100
    },
    revenueIncrease() {
      let current = this.total[this.selectedTotal.revenue].current ? this.total[this.selectedTotal.revenue].current.income - this.total[this.selectedTotal.revenue].current.expense : 0
      let previous = this.total[this.selectedTotal.revenue].previous ? this.total[this.selectedTotal.revenue].previous.income - this.total[this.selectedTotal.revenue].previous.expense : 0
      if (!current) {
        return 0
      }
      return (current - previous) / current * 100
    },
    ...mapGetters({
      config: 'config/config',
      hasPermission: 'user/hasPermission',
    })
  },
  mounted() {
    this.get()
  },
  methods: {
    selectChartDateID(chart, identifier) {
      if (this.charts[chart].dateRangeID === identifier) {
        return
      }
      this.charts[chart].dateRangeID = identifier
    },
    get() {
      (async () => {
        let reports = {
          total: await axios.get('reports/total/all'),
          month: await axios.get('reports/total/compare/current-month'),
          week: await axios.get('reports/total/compare/current-week'),
          day: await axios.get('reports/total/compare/current-day'),
        }

        Promise.all(Object.values(reports))
          .then(values => {
            this.total.grant = Object.assign({}, this.reorder(values[0].data))
            this.total.month = Object.assign({}, this.reorderCompare(values[1].data))
            this.total.week = Object.assign({}, this.reorderCompare(values[2].data))
            this.total.day = Object.assign({}, this.reorderCompare(values[3].data))
          })
      })()
    },
    reorder(totals) {
      let income = totals.filter(t => t.type === 'income')
      let expense = totals.filter(t => t.type === 'expense')
      return {
        income: income && income.length ? parseFloat(income[0].total) : null,
        expense: expense && expense.length ? parseFloat(expense[0].total) : null,
      }
    },
    reorderCompare(totals) {
      let t = {}
      for (let i in totals) {
        if (totals[i] && totals[i].length) {
          t[i] = this.reorder(totals[i])
        }
      }
      return t
    }

  }
}
</script>
